import React from 'react'
import { Link } from 'react-router-dom'
import './Grid.css'

const GridItem = ({ project }) => {

    const { name, image, id } = project

    return (
        <figure className={`gallery_item--${id} gallery_container`}>
            <Link to={`/projects/${id}`}>
                <div
                    className="background_image"
                    style={{
                        background: `url('${image}')`
                    }}>
                    <div className="overlay"></div>
                    <h1 className="background_head">{name}</h1>
                </div>
            </Link>
        </figure>
    )
}

export default GridItem
